<template>
  <b-modal ref="StickyElement"
           :title="$t('ct-sticky-video')"
           @close="close()"
           @hidden="close()"
           data-component="modal-bootstrap-vue"
           no-close-on-backdrop hide-footer>
    <p class="alert-info text-center">{{ $t('ct-explaining-sticky-video') }}</p>
    <div class=" d-flex justify-content-center align-items-center">
      <div class="tamanhos mb-2">
        <button id="btnSizeSmall" type="button" class="btn btn-outline-info btnSizeSticky" @click="size('small')">
          {{ $t('ct-sticky-small') }}
        </button>
        <button id="btnSizeMedium" type="button" class="btn btn-outline-info btnSizeSticky" @click="size('medium')">
          {{ $t('ct-sticky-medium') }}
        </button>
        <button id="btnSizeLarge" type="button" class="btn btn-outline-info btnSizeSticky" @click="size('large')">
          {{ $t('ct-sticky-large') }}
        </button>
      </div>
    </div>
    <div class="border border-primary">
      <div class="d-flex align-items-center h-100">
        <div class="flex-1 d-flex justify-content-center align-items-center flex-column">
          <button type="button" class="btn btn-outline-primary btClick btnColor-1"
                  @click="border('top-left')"></button>
          <button id="bot-click" type="button" class="btn btn-outline-primary"></button>
          <button type="button" class="btn btn-outline-primary btClick btnColor-3"
                  @click="border('bottom-left')"></button>
        </div>
        <div class="flex-1 d-flex justify-content-center align-items-center flex-column">
          <button id="bot-click" type="button" class="btn btn-outline-primary"></button>
          <button id="bot-click" type="button" class="btn btn-outline-primary "></button>
          <button id="bot-click" type="button" class="btn btn-outline-primary "></button>
        </div>
        <div class="flex-1 d-flex justify-content-center align-items-center flex-column">
          <button type="button" class="btn btn-outline-primary btClick btnColor-7"
                  @click="border('top-right')"></button>
          <button id="bot-click" type="button" class="btn btn-outline-primary "></button>
          <button type="button" class="btn btn-outline-primary btClick btnColor-9"
                  @click="border('bottom-right')"></button>
        </div>
      </div>
    </div>
    <p class="alert-info text-center" style="margin: 5px">{{ $t('ct-sticky-remove-rotate') }}</p>
    <div class="d-flex justify-content-center align-items-center py-2 not-sticky">
      <button slot="button" class="btn btn-outline-danger mb-3" @click="remove()">
        {{ $t('ct-fix-remove') }}
      </button>
    </div>
    <div class="d-flex justify-content-end align-items-center">
      <button
        slot="button"
        class="btn btn-primary"
        data-ba-i="sticky-item"
        @click="confirm()"
      >{{ $t('ct-sticky-okay') }}
      </button>
    </div>
  </b-modal>
</template>

<script>

export default {
  name: "ModalSticky",
  props: ["text", "show", "values"],
  data() {
    return {
      element: null
    };
  },
  methods: {
    openModal() {
      this.$refs['StickyElement'].show();
    },

    hideModal() {
      this.$refs['StickyElement'].hide();
    },

    size(type) {
      this.element.internal_config.sizeSticky = type;

      //marcadores
      if (this.element.internal_config.sizeSticky == 'small') {
        $('.btnSizeSticky').css('background-color', '#ffff');
        $('#btnSizeSmall').css('background-color', '#05c1fc');

      } else if (this.element.internal_config.sizeSticky == 'medium') {
        $('.btnSizeSticky').css('background-color', '#ffff');
        $('#btnSizeMedium').css('background-color', '#05c1fc');

      } else {
        $('.btnSizeSticky').css('background-color', '#ffff');
        $('#btnSizeLarge').css('background-color', '#05c1fc');
      }

    },

    border(type) {
      var elemento = document.getElementById(this.element.id);

      switch (type) {
        case "top-left":
          this.element.internal_config.positionSticky = "top-left"
          this.element.internal_config.btnClick = ".btnColor-1";
          break;

        case "top-right":
          this.element.internal_config.positionSticky = "top-right"
          this.element.internal_config.btnClick = ".btnColor-7";
          break;

        case "bottom-left":
          this.element.internal_config.positionSticky = "bottom-left"
          this.element.internal_config.btnClick = ".btnColor-3";
          break;

        case "bottom-right":
          this.element.internal_config.positionSticky = "bottom-right"
          this.element.internal_config.btnClick = ".btnColor-9";
          break;
      }
      this.element.internal_config.StickyVideo = true;


      //marcadores

      if (this.element.internal_config.btnClick == null) {
        $('.btClick').css('background-color', '#ffff');
      } else {
        $('.btClick').css('background-color', '#ffff');
        $(`${this.element.internal_config.btnClick}`).css('background-color', '#6495ED');
      }
      ;
    },
    remove() {
      this.element.internal_config.ative = false;
      this.element.internal_config.StickyVideo = false;
      this.element.internal_config.sizeSticky = '';
      this.element.internal_config.btnClick = '';
      $('.btClick').css('background-color', '#ffff');
      $('.btnSizeSticky').css('background-color', '#ffff');
      this.$root.$emit("hideStickyElement");
    },
    confirm() {
      if (this.element.internal_config.sizeSticky == '') {

        this.$snotify.error(this.$t('ct-sizeSticky-error'));
        return false;

      }
      if (this.element.internal_config.positionSticky == '') {

        this.$snotify.error(this.$t('ct-positionSticky-error'));
        return false;

      } else {
        this.element.internal_config.ative = true;
        this.$root.$emit("hideStickyElement");

      }
    },
    close() {
      // console.log(this.element.internal_config.ative, 'opa')

      if (this.element.internal_config.ative) {
        this.$root.$emit("hideStickyElement");
      } else {
        this.element.internal_config.StickyVideo = false;
        this.element.internal_config.sizeSticky = '';
        this.element.internal_config.btnClick = '';
        $('.btClick').css('background-color', '#ffff');
        $('.btnSizeSticky').css('background-color', '#ffff');
        this.$root.$emit("hideStickyElement");
      }
    },
    setValues(elem) {
      this.element = elem;
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.border {
  margin-left: auto;
  margin-right: auto;
  width: 240px;
  border: 5px solid #007bff !important;
  height: 163px;
  border-radius: 10px 10px;
}

.btn-outline-info {
  width: 32px;
  left: 3%;
  margin: 5px;
  color: #000;

}

.active {
  background-color: rgb(4, 38, 102) !important;
}

#bot-click {
  background-color: #d3d3d3;
  border: none !important;
  font-size: 0;
  cursor: not-allowed;
}

.btn-outline-primary {
  width: 32px !important;
  height: 32px;
  margin-bottom: 4px !important;
  margin-top: 4px !important;
}

@media (min-width: 900px) {
  .tamanhos {
    width: 230px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/editor/base/Sticky.vue